export const REACTION_CHAT_TYPES = {
  DIRECT: "direct",
  GLOBAL: "global",
  GROUP: "group",
  OPPONENT_TEAM: "opponent-team",
  TEAM: "team",
  EVENT: "event",
};

export const REACTION_SOCKET = {
  [REACTION_CHAT_TYPES.DIRECT]: {
    emit: "react-message",
    listen: "messageReaction",
    buildPayload: ({ otherUserId, messageId, emoji }) => ({
      otherUserId,
      messageId,
      emoji,
    }),
  },
  [REACTION_CHAT_TYPES.GLOBAL]: {
    emit: "react-global-message",
    listen: "globalMessageReaction",
    buildPayload: ({ messageId, emoji }) => ({ messageId, emoji }),
  },
  [REACTION_CHAT_TYPES.GROUP]: {
    emit: "react-group-message",
    listen: "groupMessageReaction",
    buildPayload: ({ tournamentId, messageId, emoji }) => ({
      tournamentId,
      messageId,
      emoji,
    }),
  },
  [REACTION_CHAT_TYPES.OPPONENT_TEAM]: {
    emit: "react-opponent-team-message",
    listen: "opponentMessageReaction",
    buildPayload: ({ conversationId, messageId, emoji }) => ({
      conversationId,
      messageId,
      emoji,
    }),
  },
  [REACTION_CHAT_TYPES.TEAM]: {
    emit: "react-team-message",
    listen: "teamMessageReaction",
    buildPayload: ({ teamId, messageId, emoji }) => ({
      teamId,
      messageId,
      emoji,
    }),
  },
  [REACTION_CHAT_TYPES.EVENT]: {
    emit: "react-event-message",
    listen: "eventMessageReaction",
    buildPayload: ({ eventId, messageId, emoji }) => ({
      eventId,
      messageId,
      emoji,
    }),
  },
};

export const getReactionConfig = (chatType) =>
  REACTION_SOCKET[chatType] || null;
